import { render, staticRenderFns } from "./EficienciaAgenciaPage.vue?vue&type=template&id=7efe8dcb&scoped=true"
import script from "./EficienciaAgenciaPage.vue?vue&type=script&lang=js"
export * from "./EficienciaAgenciaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efe8dcb",
  null
  
)

export default component.exports